export type PdfLayoutOption = "portrait" | "landscape";

const PDF_LAYOUT_MAX_WIDTH: Record<PdfLayoutOption, number> = {
    // These two widths are what puppeteer is supposed to use, but think we should make them bigger on the general UI
    // portrait: 622,
    // landscape: 894,
    // These two widths are 1.5x bigger than the two above
    portrait: 933,
    landscape: 1341,
};

const DEFAULT_MAX_WIDTH = PDF_LAYOUT_MAX_WIDTH.landscape;

type DictionaryEntryWithPdfLayout = {
    pdf_layout?: unknown;
};

type DictionaryWithPdfLayout = Record<string, DictionaryEntryWithPdfLayout | undefined>;

export function resolvePdfLayout(layoutValue: unknown): PdfLayoutOption | null {
    if (typeof layoutValue !== "string") {
        return null;
    }

    const normalized = layoutValue.trim().toLowerCase();

    if (normalized === "portrait" || normalized === "landscape") {
        return normalized;
    }

    return null;
}

export function resolveSectionMaxWidth(
    dictionary: DictionaryWithPdfLayout,
    sectionId: string,
    fallbackWidth: number = DEFAULT_MAX_WIDTH
): number {
    const layout = resolvePdfLayout(dictionary[sectionId]?.pdf_layout);

    if (layout) {
        return PDF_LAYOUT_MAX_WIDTH[layout];
    }

    return fallbackWidth;
}

export function getDefaultPdfLayoutMaxWidth(): number {
    return DEFAULT_MAX_WIDTH;
}
